module.exports = __webpack_public_path__ + "static/media/Carousel Image 6.bb5d5f56.png";